<template>
<label for="Email" class="c-form_label" :for="id" :class="{'-required': required}">
    {{ labelText }}
</label>
<input class="c-form_input" 
    type="tel" 
    :id="id" 
    :name="name" 
    :placeholder="placeholder" 
    :required="required" 
    :autocomplete="autocomplete" 
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
>
<div class="c-form_validation">
    <div class="c-form_validation_required">
        {{ _t("Enter a value for this field.") }}
    </div>
    <div class="c-form_validation_invalid">
        {{ _t("This field is invalid.") }}
    </div>
</div>
</template>
<script>
export default {
    name: 'Email',
    props: {
        id: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        labelText: {
            type: String,
            default: ''
        },
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    }
}
</script>